module.exports = __webpack_public_path__ + "img/7_36.a28df5bf.png";